// extracted by css-extract-rspack-plugin
export default {"sectionIntro":"PricingSection-module__sectionIntro__KPHIMNO"};